import React from 'react';
import { Layout } from 'antd'
const {  Content } = Layout
class LayoutHome extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            menuList:[]
        }
    }


    render() {

        return (
            <Layout className='main_layout'>
                <div className='layout_div'>
                    <Content>
                        {this.props.children}
                    </Content>
                </div> 
                    
            </Layout>
        )
    }
}
export default LayoutHome